/**
 * A competition's URL slot (/competitions/:competitionRef) takes its readable slug ("crno-belo-2025"). The old links
 * with the id keep working - an id is recognised and used directly, anything else is looked up as a slug.
 */
const GUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function isGuid(value: string | undefined): boolean {
  return Boolean(value && GUID.test(value));
}
